<template>
  <v-card
    flat
    next
    class="mb-1"
  >
    <v-card-title class="pa-0">
      <p class="font-weight-medium ma-2">
        Проекти
      </p>
      <div id="btnAddClientProject">
        <v-menu
          v-model="projectMenu"
          offset-x
          bottom
          close-on-click
          :close-on-content-click="false"
          :disabled="isNew"
          :nudge-width="400"
          attach="#btnAddClientProject"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              small
              :disabled="isNew"
              v-on="on"
            >
              Додати проект
            </v-btn>
          </template>
          <AddProject
            :client-id="clientId"
            @add="addProject"
            @close="projectMenu = false"
          />
        </v-menu>
      </div>
      <v-spacer />
      <CustomTextField
        v-if="projects.length > 6"
        v-model="search"
        placeholder="Введіть назву проекту"
        clearable
        :disabled="projects.length === 0"
        class="ml-1"
      >
        <template v-slot:append>
          <v-icon>search</v-icon>
        </template>
      </CustomTextField>
    </v-card-title>

    <v-card-text
      v-show="filteredProjects.length"
      class="pb-0"
    >
      <v-data-table
        :headers="headers"
        :items="filteredProjects"
        :items-per-page="10"
        :search="search"
        dense
        :hide-default-footer="projects.length < 11"
        :footer-props="{
          itemsPerPageText: 'Рядків на сторінці',
          itemsPerPageAllText: 'Всі'
        }"
        no-results-text="На жаль, нічого не знайдено"
        no-data-text="Дані відсутні"
      >
        <template v-slot:[`item.title`]="props">
          <JiraProjectLink :project-key="props.item.key" />
          {{ props.item.title }}
        </template>
        <template v-slot:[`item.fixPrice`]="props">
          <v-chip
            class="ma-2"
            label
            x-small
            :color="props.item.fixPrice ? 'red' : 'green'"
            text-color="white"
          >
            {{ props.item.fixPrice ? "Так" : "Ні" }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import AddProject from "./AddProject.vue";
import JiraProjectLink from "@/components/JiraProjectLink.vue";

export default {
  components: {
    AddProject,
    JiraProjectLink,
  },
  props: ["projects", "isNew", "clientId"],
  data: () => ({
    projectMenu: false,
    search: "",
    headers: [
      {
        text: "Назва",
        align: "left",
        value: "title",
      },
      {
        text: "Fix Price",
        align: "left",
        value: "fixPrice",
      },
    ],
  }),
  computed: {
    filteredProjects() {
      if (this.search) {
        return this.projects.filter((el) =>
          el.title.toLowerCase().includes(this.search.toLowerCase())
        );
      }
      return this.projects;
    },
  },
  methods: {
    addProject(project) {
      this.$emit("add", project);
      this.search = "";
    },
  },
};
</script>
